import React from 'react';

import MaterialGrid from '@mui/material/Grid/Grid';

import { useTranslation } from '@ezbobdev/ui-framework';

import MaterialTypography from '../../MaterialTypography/MaterialTypography';

export const PhonePopoverContent = (props) => {
  const { iconSrc, configByName } = props;

  const { t } = useTranslation();

  return (
    <>
      <MaterialGrid justifyContent="center" display="flex" item>
        <img src={iconSrc} alt={t(`${configByName}.phone.popover.iconAlt`)} />
      </MaterialGrid>

      <MaterialGrid item>
        <MaterialTypography align="center" variant="h2">
          {t(`${configByName}.phone.popover.title`)}
        </MaterialTypography>
      </MaterialGrid>

      <MaterialGrid item>
        <MaterialTypography variant="body1" className="bold-600">
          {t(`${configByName}.phone.popover.workingHoursTitle`)}
        </MaterialTypography>
      </MaterialGrid>

      <div>
        <MaterialTypography className="workingHours" variant="body1">
          {t(`${configByName}.phone.popover.workingHoursContent`)}
        </MaterialTypography>

        <MaterialTypography className="phoneLink" variant="button">
          {t(`${configByName}.phone.popover.phoneLink`)}
        </MaterialTypography>
      </div>
    </>
  );
};
